import { isSPARoute } from '../../helpers/routing/route.helpers';
import { useRouterHistory } from '../routing/history.hook';

// For when we need to trigger navigation programmatically.
// Will handle our link object and navigate them externally if needed.
export const useNavigation = () => {
	const history = useRouterHistory();
	return (url: string, replace?: boolean) => {
		const isOnlyParamChange = url.startsWith('?');
		const isSPAEnabled = isSPARoute(url);
		if (isOnlyParamChange || isSPAEnabled) {
			if (replace) {
				history.replace(url);
			} else {
				history.push(url);
			}
		} else {
			if (replace) {
				window.location.replace(url);
			} else {
				window.location.assign(url);
			}
		}
	};
};
